export default "__VITE_ASSET__BfzCV8lA__"